export default __webpack_public_path__ + "static/media/pic4.df5da6d7.jpg";